const updateSidebarActive = () => {
  const currentUrl = new URL(window.location.href)
  const currentPath = currentUrl.pathname
  const currentSearchParams = currentUrl.searchParams
  const sidebar = document.querySelector('#sidebarnav')
  if (!sidebar) return

  const allLinks = sidebar.querySelectorAll('.sidebar-link, .sublink')
  const topLinks = sidebar.querySelectorAll('.sidebar-link.has-arrow')

  // Reset all state
  allLinks.forEach(l => l.classList.remove('active', 'selected'))
  topLinks.forEach(l => l.classList.remove('active', 'selected'))
  sidebar.querySelectorAll('ul.collapse.show').forEach(ul => ul.classList.remove('show', 'in'))

  let bestMatch = null
  let bestScore = -1

  allLinks.forEach(link => {
    const href = link.getAttribute('href')
    if (!href || href.startsWith('javascript:')) return

    try {
      const url = new URL(href, window.location.origin)
      if (url.pathname !== currentPath) return

      let score = 0
      url.searchParams.forEach((value, key) => {
        if (currentSearchParams.get(key) === value) score++
      })

      if (score > bestScore) {
        bestScore = score
        bestMatch = link
      }
    } catch {}
  })

  if (!bestMatch) return

  // ✅ Activate the current link
  bestMatch.classList.add('active', 'selected')

  // ✅ Expand parent hierarchy
  let parent = bestMatch.parentElement
  while (parent) {
    if (parent.classList.contains('collapse')) {
      parent.classList.add('show', 'in')
    }

    const parentSidebarItem = parent.closest('li.sidebar-item')
    if (parentSidebarItem) {
      const parentLink = parentSidebarItem.querySelector('.sidebar-link.has-arrow')
      if (parentLink) {
        parentLink.classList.add('active', 'selected')
      }
    }

    parent = parent.parentElement
  }

  // 🧹 Close other branches (not ancestors of bestMatch)
  sidebar.querySelectorAll('ul.collapse').forEach(ul => {
    if (!ul.contains(bestMatch)) {
      ul.classList.remove('show', 'in')
      const parentItem = ul.closest('li.sidebar-item')
      if (parentItem) {
        parentItem.classList.remove('active', 'selected')
      }
    }
  })
}

// Turbo-safe load
document.addEventListener('turbo:render', () => requestAnimationFrame(updateSidebarActive))
document.addEventListener('turbo:load', updateSidebarActive)
document.addEventListener('DOMContentLoaded', updateSidebarActive)
